<template>
  <!-- TODO: max height is height for all elements -->
  <div class="step-descriptor-container">
    <TText
      :value="translatable ? step_name : false" 
      :text="step_name"
      :color="foreground_color"
      :size="13"
      :font_weight="400"
      align="left"
      :line_height="1.1"
      :max_lines="3"
    />
    <div class="step-descriptor-property-container">
      <div
        v-for="(property, index) in properties"
        :key="`${property.name}${index}`"
        class="step-descriptor-property"
      >
        <TIcon
          v-if="property.icon"
          :name="property.icon"
          :color="transparent_fg"
          small
        />
        <TText
          :text="property.value"
          :color="transparent_fg"
          small
          :font_weight="400"
        />
      </div>
      <div v-if="total" class="step-descriptor-property-total">
        <TIcon
          :name="total.icon"
          :color="transparent_fg"
          small
        />
        <TText
          :text="`${total.value} ${total.unit}`"
          :color="transparent_fg"
          small
          :font_weight="400"
          :key="total.value"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { TColor } from '@/mixins/TColor.mixin.js';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';

  export default {
    components: {
      TText,
      TIcon,
    },

    mixins: [
      TColor,
    ],

    props: [
      'step_name', // is string, contains description of step
      'properties', // is array of objects, contains name, icon (string) and value (number)
      'total', // is object, contains total (number) and type (string)
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'translatable' // boolean, if step_name is translatable
    ],

    computed: {
      transparent_fg() {
        return this.getTranspHexColor(this.foreground_color, .5);
      },
    },

    data: () => ({

    }),
  }
</script>

<style>
.step-descriptor-container {
  display: flex;
  flex-direction: column;
  grid-gap: 4px;
  width: 100%;
}
.step-descriptor-property-container {
  text-align: left;
  display: flex;
  grid-gap: 8px;
  align-items: center;
}
.step-descriptor-property-total {
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  grid-gap: 4px;
  align-items: center;
  height: 20px;
}
.step-descriptor-property {
  display: flex;
  grid-gap: 4px;
  /* min-width: 50px; */
}
</style>
